var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert-box",class:_vm.boxClass},[_c(_vm.tag,{tag:"component",class:_vm.headingClass},[(_vm.icon)?_c('icon',{attrs:{"name":_vm.icon}}):_vm._e(),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.text)}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }